import { Directive } from '@angular/core';
import { NgpPopover } from 'ng-primitives/popover';

/**
 * `[suiPopover]` — the popover panel marker. Goes on the root element inside the
 * trigger's `<ng-template>` (e.g. `<div suiPopover class="...">`). ng-primitives
 * portals that element into the configured container and positions it with
 * floating-ui.
 *
 * Deliberately **style-free** (no surface/radius/shadow/padding): popover content
 * is arbitrary consumer markup that brings its own styling, so this only hosts
 * `NgpPopover` — which wires the overlay id/aria and a focus-trap (Tab cycles
 * within the panel; closes on Esc / outside-click via the trigger). It is the
 * panel half of the thin wrapper, keeping app code on sui vocabulary instead of
 * touching `[ngpPopover]` directly. The default-chrome shell stays deferred until
 * a site actually needs standard surface styling.
 */
@Directive({
  selector: '[suiPopover]',
  standalone: true,
  hostDirectives: [NgpPopover],
})
export class SuiPopoverDirective {}
